import { render, staticRenderFns } from "./BasePaySuccess.vue?vue&type=template&id=1a856128&scoped=true&"
import script from "./BasePaySuccess.vue?vue&type=script&lang=js&"
export * from "./BasePaySuccess.vue?vue&type=script&lang=js&"
import style0 from "./BasePaySuccess.vue?vue&type=style&index=0&id=1a856128&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a856128",
  null
  
)

export default component.exports